import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDashboardList = createAsyncThunk("fetchDashboardList", async () => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`analytics/dashboard/list`, config);

	return response.data.data;
});


const DashboardListSlice = createSlice({
	name: "dashboardListSlice",
	initialState: {
		isLoading: false,
		data: { create: true },
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDashboardList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDashboardList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchDashboardList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DashboardListSlice.reducer;
